export default __webpack_public_path__ + "static/media/calendar-people-image.00a95e80.png";